import { forwardRef, type Ref, type SVGProps } from "react";
const IconPedestrianOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M25 17.43a2.83 2.83 0 0 0-.81-1.9l-1.11-1.16-.49-1.56a8.17 8.17 0 0 0-2.28-3.55A4 4 0 1 0 14 6a3.93 3.93 0 0 0 .62 2.12c-.88.3-2.07.86-2.78 1.19l-.49.21a6 6 0 0 0-3.08 3l-.67 1.55a2.85 2.85 0 0 0 1.5 3.81 3 3 0 0 0 1.19.26 2.76 2.76 0 0 0 1.85-.71v.22l-.8 2.13-.91 2.44-2.64 2.87A2.91 2.91 0 0 0 9.88 30a2.83 2.83 0 0 0 2.12-.92l2.64-2.81a6.1 6.1 0 0 0 1.24-2l.46-1.27.58.59a.2.2 0 0 1 .06.1l.87 4.05A2.91 2.91 0 0 0 20.66 30a2.84 2.84 0 0 0 2.82-3.51l-.88-4.06a6.2 6.2 0 0 0-.82-2h.31a3 3 0 0 0 2.91-3M16 6a2 2 0 1 1 2 2 2 2 0 0 1-2-2m-1.85 17.68a4.1 4.1 0 0 1-.88 1.41l-2.63 2.8a1.1 1.1 0 0 1-.76.35 1 1 0 0 1-.77-.35 1.2 1.2 0 0 1 0-1.62l2.62-2.81a1.8 1.8 0 0 0 .41-.64l.91-2.43.07.06 1.63 1.6zm7.21-5.32L20 17a2.75 2.75 0 0 1-.61-1.06c-.64-2.05-.65-2.18-1-2.65l-1.19 5 2.42 2.37a4.34 4.34 0 0 1 1.17 2.15l.89 4.06a1.15 1.15 0 0 1-.82 1.38.7.7 0 0 1-.25 0 1.11 1.11 0 0 1-1-.89l-.88-4.05a1.9 1.9 0 0 0-.53-1l-3.56-3.49a2.88 2.88 0 0 1-.66-2.6l.88-3.79c-.52.18-1 .4-2 .82a2 2 0 0 0-1 1l-.63 1.45a1 1 0 0 1-.94.69 1.16 1.16 0 0 1-1.14-1.18 1.3 1.3 0 0 1 .12-.47l.65-1.48a4.27 4.27 0 0 1 2.18-2.15c1.91-.83 2.73-1.25 4.3-1.25a4.75 4.75 0 0 1 4.49 3.45l.58 1.85a.34.34 0 0 0 .1.16l1.31 1.38a1.15 1.15 0 0 1 0 1.66 1.3 1.3 0 0 1-.74.32 1 1 0 0 1-.78-.32"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPedestrianOutlineSVG);
ForwardRef.displayName = "IconPedestrianOutline";
export { ForwardRef as IconPedestrianOutline };
